import React from 'react'
import Icon from '@/atoms/Icon'

import { StyledInfo } from './styles'

const Info = ({
  typo = 'labelBig',
  className,
  label,
  icon,
  iconSize = 16,
  ariaLabel
}) => (
  <StyledInfo
    className={className}
    typo={typo}
    iconSize={iconSize}
    {...ariaLabel ? { 'aria-label': ariaLabel } : {}}
  >
    {
      !!icon &&
      <Icon
        name={icon}
        {...ariaLabel ? { 'aria-hidden': true } : {}}
      />
    }
    <span {...ariaLabel ? { 'aria-hidden': true } : {}}>
      {label}
    </span>
  </StyledInfo>
)
export default Info
